import { render } from "./guanliyuancaozuorizhi.vue?vue&type=template&id=16e9963f&scoped=true"
import script from "./guanliyuancaozuorizhi.vue?vue&type=script&lang=js"
export * from "./guanliyuancaozuorizhi.vue?vue&type=script&lang=js"

import "./guanliyuancaozuorizhi.vue?vue&type=style&index=0&id=16e9963f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e9963f"]])

export default __exports__